module.exports = __webpack_public_path__ + "img/whale2.84fee63f.png";